const tablesettings = Object.assign({}, ...["Signer", "Bank", "mainContentDigitalSignatures", "AdditionalDocument", "FilesAttachments", "MainContent", "MenuLinks", "AdditionalFiles"]
    .map((item) => ({ [item]: require(`./${item}.js`).default })));
export const clientSettings={
 table: JSON.parse(JSON.stringify(tablesettings))
}